import React from 'react';
import { ReactComponent as LoadingRingsIcon } from '../../../icons/loading-rings.svg';
import './conversation-list-loading.scss';

const ConversationListLoading: React.FC = () => {
  return (
    <div className='conversation-list-loading-container'>
      <div className='spacer'></div>
      <div className='spacer'></div>
      <div className='spinner'>
        <LoadingRingsIcon />
      </div>
    </div>
  );
};

export default ConversationListLoading;
